"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MedicationList = void 0;
require("antd/lib/empty/style");
var _empty = _interopRequireDefault(require("antd/lib/empty"));
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _Medication = require("../Medication");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MedicationList = function MedicationList(_ref) {
  var _ref$medications = _ref.medications,
    medications = _ref$medications === void 0 ? [] : _ref$medications,
    _ref$prescribers = _ref.prescribers,
    prescribers = _ref$prescribers === void 0 ? [] : _ref$prescribers,
    collapsible = _ref.collapsible,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    _ref$adminView = _ref.adminView,
    adminView = _ref$adminView === void 0 ? false : _ref$adminView;
  var medicationsByYear = (0, _react.useMemo)(function () {
    return (0, _lodash.chain)(medications).orderBy(['writtenDate'], ['desc']).filter(function (medication) {
      return (0, _utils.isValidPrescription)(medication) || adminView;
    }).groupBy(function (medication) {
      return (0, _momentTimezone.default)(medication.writtenDate).year();
    }).values()
    // Ensure year sections are ordered as well
    .orderBy([function (m) {
      return m[0].writtenDate;
    }], ['desc']).value();
  }, [medications]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "MedicationList"
  }, !(0, _lodash.isEmpty)(medicationsByYear) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, medicationsByYear.map(function (year) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
      className: "mb-[20px]"
    }, (0, _momentTimezone.default)(year[0].writtenDate).year()), year.map(function (medication) {
      var prescriber = prescribers.find(function (p) {
        return p.erxId === "".concat(medication.prescriberId);
      });
      return /*#__PURE__*/_react.default.createElement(_Medication.Medication, _extends({
        className: "mb-[24px]",
        key: medication.prescriptionId
      }, medication, {
        prescriber: prescriber,
        bordered: bordered,
        adminView: adminView,
        collapsible: collapsible
      }));
    }));
  })) : /*#__PURE__*/_react.default.createElement(_empty.default, null));
};
exports.MedicationList = MedicationList;